module.exports = __webpack_public_path__ + "img/analysisGrowth.56099dec.png";